import { Node, mergeAttributes } from '@tiptap/core';

export const ALLOWED_HOSTS = [
  'youtube.com',
  'www.youtube.com',
  'youtube-nocookie.com',
  'www.youtube-nocookie.com',
  'youtu.be',
  'www.canva.com',
  'canva.com',
  'player.vimeo.com',
  'vimeo.com',
];

function isAllowedSrc(src: string | null) {
  if (!src) return false;
  try {
    const u = new URL(src, window.location.origin);
    return ALLOWED_HOSTS.includes(u.hostname);
  } catch {
    return false;
  }
}

/**
 * Generic iframe node — used to render embeds from trusted hosts
 * (Canva, Vimeo, etc.) that aren't covered by the dedicated YouTube node.
 */
export const Iframe = Node.create({
  name: 'iframe',
  group: 'block',
  atom: true,
  draggable: true,

  addAttributes() {
    return {
      src: { default: null },
      width: { default: '100%' },
      height: { default: null },
      frameborder: { default: '0' },
      allowfullscreen: { default: true },
      allow: { default: null },
      title: { default: null },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'iframe',
        getAttrs: (node) => {
          const el = node as HTMLElement;
          const src = el.getAttribute('src');
          if (!isAllowedSrc(src)) return false;
          // Skip YouTube — handled by the Youtube extension
          if (src && /(youtube\.com|youtu\.be|youtube-nocookie\.com)/.test(src)) {
            return false;
          }
          return {
            src,
            width: el.getAttribute('width') || '100%',
            height: el.getAttribute('height'),
            allow: el.getAttribute('allow'),
            allowfullscreen: el.hasAttribute('allowfullscreen'),
            title: el.getAttribute('title'),
          };
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      { class: 'aspect-video my-4' },
      [
        'iframe',
        mergeAttributes(HTMLAttributes, {
          class: 'w-full h-full rounded-lg',
        }),
      ],
    ];
  },
});

export default Iframe;
